import Cookies from 'js-cookie';

const cookieName = 'token';
const isSecure = window.location.protocol === 'https:';

export const setAuthToken = (token: string) => {
  Cookies.set(cookieName, token, {
    path: '/',
    sameSite: 'Lax',
    expires: 7, // TODO: move cookie expiration to the backend when login is handled by Falcon
    secure: isSecure,
  });
};

export const getAuthToken = (): string | null => {
  return Cookies.get(cookieName) ?? null;
};

export const removeAuthToken = () => {
  Cookies.remove(cookieName, { path: '/' });
};
